import React, { useState } from "react";
import {
  Avatar,
  Chip,
  IconButton,
  Tooltip,
  useMediaQuery,
  Menu,
  MenuItem,
  Divider
} from "@material-ui/core";
import { useTheme } from "@material-ui/core/styles";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import SearchIcon from "@material-ui/icons/Search";
import CloseIcon from "@material-ui/icons/Close";
import MoreVertIcon from "@material-ui/icons/MoreVert";
import InfoOutlinedIcon from "@material-ui/icons/InfoOutlined";
import { useHistory } from "react-router-dom";
import SwapHorizOutlinedIcon from "@material-ui/icons/SwapHorizOutlined";

const TicketInfo = ({
  contact,
  ticket,
  onClick,
  onToggleSearch,
  isSearching,
  onOpenKoraxMenu,
  onOpenTags,
  onOpenOpportunity,
  onOpenMission,
  onTransfer
}) => {
  const history = useHistory();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const [anchorEl, setAnchorEl] = useState(null);

  const closeMenu = () => setAnchorEl(null);

  const statusMeta =
    ticket?.status === "pending"
      ? { label: "IA", color: "#7C3AED", bg: "rgba(124,58,237,.12)" }
      : ticket?.status === "open"
      ? { label: "Atendendo", color: "#16A34A", bg: "rgba(34,197,94,.12)" }
      : ticket?.status === "group"
      ? { label: "Grupo", color: "#D97706", bg: "rgba(245,158,11,.14)" }
      : { label: "Conversa", color: "#2563EB", bg: "rgba(37,99,235,.10)" };

  const itemStyle = {
    fontSize: 13,
    fontWeight: 650,
    minHeight: 38,
    paddingTop: 7,
    paddingBottom: 7
  };

  return (
    <div style={{ display: "flex", alignItems: "center", gap: isMobile ? 3 : 6, width: "100%", minWidth: 0 }}>
      {isMobile && (
        <IconButton size="small" onClick={() => history.push("/tickets")} style={{ color: "#2563EB", flexShrink: 0, width: 34, height: 34, padding: 5 }}>
          <ArrowBackIcon style={{ fontSize: 22 }} />
        </IconButton>
      )}

      <div
        onClick={onClick}
        style={{
          display: "flex",
          alignItems: "center",
          gap: isMobile ? 7 : 9,
          flex: 1,
          minWidth: 0,
          cursor: "pointer"
        }}
      >
        <Avatar
          src={contact?.urlPicture}
          alt={contact?.name}
          style={{
            width: isMobile ? 36 : 40,
            height: isMobile ? 36 : 40,
            background: "#2563EB",
            fontWeight: 800,
            fontSize: isMobile ? 13 : 14,
            boxShadow: "0 0 0 2px rgba(37,99,235,.10)",
            flexShrink: 0
          }}
        >
          {(contact?.name || "C").charAt(0)}
        </Avatar>

        <div style={{ minWidth: 0, flex: 1 }}>
          <div style={{ display: "flex", alignItems: "center", gap: 5, minWidth: 0 }}>
            <div
              style={{
                color: "#0F172A",
                fontWeight: 750,
                fontSize: isMobile ? 13.5 : 14.5,
                lineHeight: 1.15,
                letterSpacing: "-0.015em",
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis"
              }}
            >
              {contact?.name || "Contato"}
            </div>
            <span style={{ width: 6, height: 6, borderRadius: "50%", background: "#22C55E", flexShrink: 0 }} />
          </div>

          <div style={{ display: "flex", alignItems: "center", gap: 5, marginTop: 2 }}>
            <Chip
              size="small"
              label={statusMeta.label}
              style={{
                height: 18,
                borderRadius: 999,
                fontSize: 9,
                fontWeight: 750,
                maxWidth: isMobile ? 78 : 100,
                background: statusMeta.bg,
                color: statusMeta.color
              }}
            />
            <span
              style={{
                color: "#64748B",
                fontSize: isMobile ? 10.5 : 11,
                lineHeight: 1.2,
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis"
              }}
            >
              {ticket?.user?.name ? `Responsável: ${ticket.user.name}` : "Central de conversas"}
            </span>
          </div>
        </div>
      </div>

      <Tooltip title={isSearching ? "Fechar busca" : "Buscar mensagens"}>
        <IconButton size="small" onClick={e => { e.stopPropagation(); onToggleSearch && onToggleSearch(); }} style={{ color: "#64748B", width: 32, height: 32, padding: 5 }}>
          {isSearching ? <CloseIcon style={{ fontSize: 19 }} /> : <SearchIcon style={{ fontSize: 19 }} />}
        </IconButton>
      </Tooltip>

      {!isMobile && (
        <Tooltip title="Detalhes do contato">
          <IconButton size="small" onClick={onClick} style={{ color: "#64748B", width: 32, height: 32, padding: 5 }}>
            <InfoOutlinedIcon style={{ fontSize: 19 }} />
          </IconButton>
        </Tooltip>
      )}

      <Tooltip title="Transferir atendimento" arrow>
        <IconButton
          size="small"
          aria-label="Transferir atendimento"
          onClick={event => {
            event.stopPropagation();

            if (onTransfer) {
              onTransfer();
            }
          }}
          style={{
            color: "#155EEF",
            width: 34,
            height: 34,
            padding: 5,
            flexShrink: 0,
            borderRadius: 10,
            border: "1px solid rgba(21,94,239,.16)",
            background: "rgba(21,94,239,.07)"
          }}
        >
          <SwapHorizOutlinedIcon style={{ fontSize: 20 }} />
        </IconButton>
      </Tooltip>

      
    </div>
  );
};

export default TicketInfo;
